var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ship"},[(_vm.shipName)?_c('canvas',{attrs:{"id":("ship-" + _vm.shipFileName),"width":_vm.canvasWidth,"height":_vm.canvasHeight}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }